import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiCallGetKpiMatrix, apiCallGetKPIUserHistory } from "../../Core/Apicall.js";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../Config/Actions/loadingActions.js";
import EmptyData from "../../Components/EmptyData/EmptyData.js";
import CustomPagination from "../../Components/CustomPagination/CustomPagination.js";
import AmbassadorTrackList from "../../Components/AmbassadorTrack/AmbassadorTrackList.js";
import Icons from "../../Constants/Icons.js";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { toast } from "react-toastify";
import UserTrackHistoryModal from "../../Components/AmbassadorTrack/UserTrackHistoryModal.js";

const AmbassadorTrack = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.isLoading);
  const [ambassadorData, setAmbassadorData] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [initialPage, setInitialPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [historyData, setHistoryData] = useState([]);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    const now = new Date();
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(now.getMonth() - 6);

    setStartDate(sixMonthsAgo);
    setEndDate(now);

    fetchKpiTrackingData(0, sixMonthsAgo, now);
  }, []);

  const fetchKpiTrackingData = async (
    selectedPage = initialPage,
    sDate = startDate,
    eDate = endDate
  ) => {
    try {
      // Validation
      if (sDate && eDate && new Date(eDate) < new Date(sDate)) {
        toast.error("End date cannot be before start date");
        return;
      }

      dispatch(setLoadingTrue());

      const params = {
        page: selectedPage + 1,
        limit: 10,
        startDate: sDate,
        endDate: eDate,
      };

      const response = await apiCallGetKpiMatrix(params);

      setTotalCount(response?.totalCount ?? 0);
      setInitialPage(selectedPage ?? 0);
      setAmbassadorData(response.data || []);
    } catch (error) {
      console.error("Fetch KPI Error:", error);
      toast.error("Failed to fetch KPI data");
    } finally {
      dispatch(setLoadingFalse());
    }
  };

  const handleHistory = async (item) => {
    try {
      dispatch(setLoadingTrue());
      const res = await apiCallGetKPIUserHistory({
        userId: item.userId,
      });
      if (res.success) {
        setHistoryData(res.data || []);
        setShowHistoryModal(true);
        setSelectedUser(item);
      } else {
        toast.error(res.message || "Failed to fetch history");
      }
    } catch (e) {
      console.error("History Error:", e);
      toast.error("Failed to fetch user history");
    } finally {
      dispatch(setLoadingFalse());
    }
  };

  const handleApplyFilter = () => {
    fetchKpiTrackingData(0);
  };

  const handleClearFilter = () => {
    const now = new Date();
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(now.getMonth() - 6);
    setStartDate(sixMonthsAgo);
    setEndDate(now);
    fetchKpiTrackingData(0, sixMonthsAgo, now);
  };

  return (
    <div>
      <div className='astrologers-list-parent padding-top-bottom'>
        <div className='custom-header-date-row'>
          <div style={{ alignItems: 'center', }} className="filter-group">
            <div style={{ marginRight: '30px' }} className="filter-item">
              <DatePicker
                selected={startDate}
                maxDate={new Date()}
                onChange={(date) => setStartDate(date)}
                dateFormat="yyyy-MM-dd"
                className="date-picker-input"
                customInput={
                  <div className="date-picker-custom">
                    <img src={Icons.ic_date} style={{ height: "20px" }} alt="calendar" />
                    <span className="date-text">
                      {startDate ? format(new Date(startDate), "MM/dd/yyyy") : "Start Date"}
                    </span>
                  </div>
                }
              />
            </div>

            <div style={{ marginRight: '30px' }} className="filter-item">
              <DatePicker
                selected={endDate}
                maxDate={new Date()}
                onChange={(date) => setEndDate(date)}
                dateFormat="yyyy-MM-dd"
                className="date-picker-input"
                customInput={
                  <div className="date-picker-custom">
                    <img src={Icons.ic_date} style={{ height: "20px" }} alt="calendar" />
                    <span className="date-text">
                      {endDate ? format(new Date(endDate), "MM/dd/yyyy") : "End Date"}
                    </span>
                  </div>
                }
              />
            </div>

            <div className="filter-actions">
              <button className="apply-btn" onClick={handleApplyFilter}>
                Apply
              </button>
              <button className="clear-btn" onClick={handleClearFilter}>
                Clear
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="Event-custom-style">
        <div className="lastWeekEndDiv Event-AlignSelf-stretch">
          <div className="user_title event-flex-container">
            Ambassador KPI Tracking
          </div>
          <div className="transparentWhite">
            <nav className="grid-cols grid_7 fontSize16WithoutFlex transparentWhite-padding">
              <div style={{ width: "25%" }} className="user_name">
                User
              </div>
              <div style={{ width: "20%" }} className="user_name">
                Activity
              </div>
              <div style={{ width: "20%" }} className="user_name">
                Goal Status
              </div>
              <div style={{ width: "20%" }} className="user_name">
                Completion
              </div>
              <div style={{ width: "15%" }} className="user_name">
                Status
              </div>
              <div style={{ width: "15%" }} className="user_name">
                Action
              </div>
            </nav>

            <AmbassadorTrackList
              data={ambassadorData}
              onHistory={handleHistory}
            />
          </div>
        </div>
      </div>

      {showHistoryModal && (
        <UserTrackHistoryModal
          data={historyData}
          user={selectedUser}
          onClose={() => {
            setShowHistoryModal(false);
            setSelectedUser(null);
            setHistoryData([]);
          }}
        />
      )}

      {ambassadorData?.length === 0 && !isLoading && (
        <div className="empty-centered">
          <EmptyData />
        </div>
      )}

      {ambassadorData?.length !== 0 && (
        <div className='Custom-Pagination'>
          <CustomPagination
            pageCount={Math.ceil(totalCount / 10)}
            pageRangeDisplayed={3}
            initialPage={initialPage}
            marginPagesDisplayed={1}
            onPageChange={({ selected }) => {
              fetchKpiTrackingData(selected);
            }}
          />
        </div>
      )}

      <style>{`
        .filter-group {
          display: flex;
          align-items: flex-end;
          gap: 16px;
          flex-wrap: wrap;
          padding: 16px 0;
        }

        .filter-item {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .filter-label {
          color: #94a3b8;
          font-size: 12px;
          font-weight: 500;
        }

        .date-picker-custom {
          display: flex;
          align-items: center;
          gap: 8px;
          background: rgba(255,255,255,0.05);
          border: 1px solid rgba(255,255,255,0.08);
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.3s;
          min-width: 150px;
        }

        .date-picker-custom:hover {
          border-color: rgba(59, 130, 246, 0.3);
        }

        .date-text {
          color: #e8edf5;
          font-size: 13px;
        }

        .filter-actions {
          display: flex;
          gap: 8px;
        }

        .apply-btn {
          padding: 8px 20px;
          background: #3b82f6;
          color: #fff;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          font-size: 13px;
          font-weight: 500;
          transition: all 0.3s;
        }

        .apply-btn:hover {
          background: #2563eb;
          transform: scale(1.02);
        }

        .clear-btn {
          padding: 8px 16px;
          background: rgba(255,255,255,0.06);
          color: #94a3b8;
          border: 1px solid rgba(255,255,255,0.08);
          border-radius: 6px;
          cursor: pointer;
          font-size: 13px;
          font-weight: 500;
          transition: all 0.3s;
        }

        .clear-btn:hover {
          background: rgba(255,255,255,0.1);
          color: #fff;
        }

        .empty-centered {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 40px 0;
        }

        .Custom-Pagination {
          margin-top: 20px;
          display: flex;
          justify-content: center;
        }

        @media (max-width: 768px) {
          .filter-group {
            flex-direction: column;
            align-items: stretch;
          }

          .filter-item {
            width: 100%;
          }

          .date-picker-custom {
            width: 100%;
          }

          .filter-actions {
            width: 100%;
          }

          .apply-btn, .clear-btn {
            flex: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default AmbassadorTrack;